import type { PortalPermissions } from '../../../shared/domain/users/permissions'
import type { AppUser } from '../../../shared/domain/users/types.no-deps'

export function doesUserHavePermission(user: AppUser, permission: PortalPermissions): boolean {
    // this goes against most permissions in that super users are not going to have it. it has to be specifically granted
    if (permission === 'restrictedUser') {
        return user.privs.portal.includes('restrictedUser')
    }

    // super users should not get confidential reports by default, they need to grant it so we can audit
    if (permission === 'confidentialReports') {
        return user.privs.portal.includes('confidentialReports')
    }

    // Super users should not see AI features if they didn't grant themselves the `aiFunctionality` permission.
    if (permission === 'aiFunctionality') {
        return user.privs.portal.includes('aiFunctionality')
    }

    // `AI Reports Access` permission is only valid if the `AI Functionality` permission is granted.
    if (permission === 'aiReportsAccess') {
        return user.privs.portal.includes('aiReportsAccess') && user.privs.portal.includes('aiFunctionality')
    }

    return user.privs.portal.includes('superUser') || user.privs.portal.includes(permission)
}
